import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import ProfileScreen from './screens/ProfileScreen';
import OrderListScreen from './screens/admin/OrderListScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import ProductEditScreen from './screens/admin/ProductEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import store from './store';
import { Provider } from 'react-redux';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import SalesForm from './screens/SaleForm';
import SupplysForm from './screens/supplyForm';
import PurchasesForm from './screens/PurchaseForm';
import HouseEditScreen from './screens/admin/HouseEditScreen'; // Import the HouseEditScreen
import HouseListScreen from './screens/admin/HouseListScreen';
import HouseScreen from './screens/HouseScreen';
import CompoundScreen from './screens/CompoundScreen';
import Apphouse from './screens/houses';
import Appcontact from './screens/contact';
import Appservices from './screens/services';
import ExpenseListScreen from './screens/admin/ExpenseListScreen';
import PaymentListScreen from './screens/admin/PaymentListScreen';
import ExpenseEditScreen from './screens/admin/ExpenseEditScreen';
import PaymentEditScreen from './screens/admin/PaymentEditScreen';
import NoteListScreen from './screens/admin/NoteListScreen';
import NoteEditScreen from './screens/admin/NoteEditScreen';
import CustomerEditSreen from './screens/admin/CustomerEditSreen';
import CustomerListScreen from './screens/admin/CustomerListScreen';
import SaleListScreen from './screens/admin/SalesListScreen';
import SaleScreen from './screens/SaleScreen';
import SupplierEditScreen from './screens/admin/SupplierEditScreen';
import SupplierListScreen from './screens/admin/SupplierListScreen';
import TransfersForm from './screens/TransferForm';
import OpeningStocksForm from './screens/OpeningStockForm';
import StocksForm from './screens/StockForm';
import ExpenseUserList from './screens/ExpenseUserList';
import ProductUserList from './screens/ProductUserList';
import CashUserList from './screens/CashUserList';
import CustomerUserList from './screens/CustomerUserList';
import SupplierUserList from './screens/SupplierUserList';
import SupplyListScreen from './screens/admin/SupplyListScreen';
import SupplyScreen from './screens/SupplyScreen';
import TransferListScreen from './screens/admin/TransferListScreen';
import TransferScreen from './screens/TransferScreen';
import StockScreen from './screens/StockScreen';
import OpeningStockScreen from './screens/OpeningStockScreen';
import StockListScreen from './screens/admin/StockListScreen';
import OpeningStockListScreen from './screens/admin/OpeningStockListScreen';
import SalesEditScreen from './screens/SalesEditScreen';
import StocksEditScreen from './screens/StockEditScreen';
import OpeningStocksEditScreen from './screens/OpeningStockEditScreen';
import TransfersEditScreen from './screens/TransferEditScreen';
import CartForm from './screens/CartForm';
import StaffSale from './screens/StaffSale';
import StaffSupply from './screens/StaffSupply';
import StaffStock from './screens/StaffStock';
import StaffOpeningStock from './screens/StaffOpeningStock';
import StaffTransfer from './screens/StaffTransfer';
import StockAnalysis from './screens/admin/StockAnalysis';
import Balance from './screens/admin/Balance';
import NetCash from './screens/admin/NetCash';
import NetCashEdit from './screens/admin/NetCashEdit';
import ExpenseScreen from './screens/ExpenseScreen';
import PaymentsScreen from './screens/PaymentsScreen';
import IncomeScreen from './screens/IncomeScreen';
import NoteScreen from './screens/NoteScreen';
import DepositScreen from './screens/DepositScreen';
import DepositEditScreen from './screens/admin/DepositEditScreen';
import DepositListScreen from './screens/admin/DepositListScreen';
import AllTotal from './screens/admin/AllTotal';
import BagScreen from './screens/BagScreen';
import BagEditScreen from './screens/admin/BagEditScreen';
import BagListScreen from './screens/admin/BagListScreen';
import StaffNote from './screens/StaffNote';
import StockReport from './screens/admin/StockReport';
import SupplysEditScreen from './screens/SupplyEditScreen';
import AdminForm from './screens/AdminForm';
import BankUserList from './screens/BankUserList';
import StaffHouseList from './screens/StaffHouseList';
import StaffHomeScreen from './screens/StaffHomeScreen';
import ProductStaffEditScreen from './screens/admin/ProductStaffEditScreen';
import ExpenseStaffEditScreen from './screens/admin/ExpenseStaffEditScreen';
import DepositStaffEditScreen from './screens/admin/DepositStaffEditScreen';
import BagStaffEditScreen from './screens/admin/BagStaffEditScreen';
import CustomerStaffEditScreen from './screens/admin/CustomerStaffEditScreen';
import SupplierStaffEditScreen from './screens/admin/SupplierStaffEditScreen';
import HouseStaffEditScreen from './screens/admin/HouseStaffEditScreen';
import AdminProfileScreen from './screens/admin/AdminProfileScreen.jsx';
import AdminUsersScreen from './screens/admin/AdminUsersScreen';
import UseStockAnalysis from  './screens/admin/useStockAnalysis.js';
import AddExpenseScreen from './screens/admin/AddExpenseScreen.jsx';
import AddPaymentScreen from './screens/admin/AddPaymentScreen.jsx';
import AddUserNote from './screens/admin/AddUserNote.jsx';
import AddIncomeScreen from './screens/admin/AddIncomeScreen.jsx';
import AddDepositScreen from './screens/admin/AddDepositScreen.jsx';
import AddStaffExpense from './screens/admin/AddStaffExpense.jsx';
import AddStaffDeposit from './screens/admin/AddStaffDeposit.jsx';
import AddStaffIncome from './screens/admin/AddStaffIncome.jsx';
import StockUniqueDates from './screens/admin/StockUniqueDates.jsx';
import WorkingCapital from './screens/admin/WorkingCapital';
import StockDateExpenses from './screens/admin/StockDateExpenses';
import ExpenseCategory from './screens/admin/ExpenseCategory';
import IncomeCategory from './screens/admin/IncomeCategory';
import ReportStockScreen from './screens/admin/ReportStockScreen.jsx';
import StartStockScreen from './screens/admin/StartStockScreen.jsx';
import SupplierBalanceScreen from './screens/admin/SupplierBalanceScreen.jsx';
import PurchaseListScreen from './screens/admin/PurchaseListScreen.jsx';
import AddNoteScreen from './screens/admin/AddNoteScreen.jsx';
import DailyStocksForm from './screens/DailyStocksForm';
import DailyStocksEditScreen from './screens/DailyStocksEditScreen';
import DailyStockAnalysis from './screens/admin/DailyStockAnalysis';
import DailyStockReport from './screens/admin/DailyStockReport';
import DailyStockUniqueDates from './screens/admin/DailyStockUniqueDates';
import StaffDailyStock from './screens/StaffDailyStock';
import DailyStockScreen from './screens/DailyStockScreen';
import DailyStockListScreen from './screens/admin/DailyStockListScreen';
import AddExpenseFromExcelScreen from './screens/admin/AddExpenseFromExcelScreen.jsx';
import AddProductsFromExcelScreen from './screens/admin/AddProductsFromExcelScreen.jsx';
import BulkProductUpdateWithImageUploadScreen from './screens/admin/BulkProductUpdateWithImageUploadScreen.jsx';
import BulkEditExpensesScreen from './screens/admin/BulkEditExpensesScreen.jsx';
import BulkIncomeUpdateWithImageUploadScreen from './screens/admin/BulkIncomeUpdateWithImageUploadScreen.jsx';
import AddIncomeFromExcelScreen from './screens/admin/AddIncomeFromExcelScreen.jsx';
import CreateMultipleProductScreen from './screens/admin/CreateMultipleProductScreen.jsx';
import IncomeExpenseCategories from './screens/admin/IncomeExpenseCategories';
import ExpenseInvoices from './screens/admin/ExpenseInvoices';
import ExpenseInvoiceSummary from './screens/admin/ExpenseInvoiceSummary';
import SupplySummary from './screens/admin/SupplySummary';
import SupplyInvoiceSummary from './screens/admin/SupplyInvoiceSummary';
import StockBulkEditScreen from './screens/admin/StockBulkEditScreen';
import BulkExcelEditHouseScreen from './screens/admin/BulkExcelEditHouseScreen.jsx';
import BulkExcelCreateHouseScreen from './screens/admin/BulkExcelCreateHouseScreen.jsx';
import InsurancesEditScreen from './screens/insurancesEditScreen.jsx';
import InsuranceScreen from './screens/insuranceScreen.jsx';
import InsurancesForm from './screens/insurancesForm.js';
import InsuranceListScreen from './screens/admin/InsuranceListScreen';
import StaffInsurance from './screens/StaffInsurance.jsx';
import CustomerImportScreen from './screens/admin/CustomerImportScreen.jsx';
import CustomerEditImportScreen from './screens/admin/CustomerEditImportScreen.jsx';
import SalesSearchReplaceScreen from './screens/admin/SalesSearchReplaceScreen.jsx';
import SupplysSearchReplaceScreen from './screens/admin/SupplysSearchReplaceScreen.jsx';
import TransfersSearchReplaceScreen from './screens/admin/TransfersSearchReplaceScreen.jsx';
import StocksSearchReplaceScreen from './screens/admin/StocksSearchReplaceScreen.jsx';
import BalanceByCustomer from './screens/admin/BalanceByCustomer';
import BalanceByCustomerStaff from './screens/admin/BalanceByCustomerStaff';
import BalanceByUserStaff from './screens/admin/BalanceByUserStaff';
import BalanceByUser from './screens/admin/BalanceByUser';
import LandlordListScreen from './screens/admin/LandlordListScreen.jsx';
import LandlordEditImportScreen from './screens/admin/LandlordEditImportScreen.jsx';
import LandlordImportScreen from './screens/admin/LandlordImportScreen.jsx';
import LandlordEditScreen from './screens/admin/LandlordEditScreen.jsx';
import TenantListScreen from './screens/admin/TenantListScreen.jsx';
import TenantEditImportScreen from './screens/admin/TenantEditImportScreen.jsx';
import TenantImportScreen from './screens/admin/TenantImportScreen.jsx';
import TenantEditScreen from './screens/admin/TenantEditScreen.jsx';
import RentEditScreen from './screens/admin/RentEditScreen.jsx';
import AddTenantScreen from './screens/admin/AddTenantScreen.jsx';
import TenantScreen from './screens/TenantScreen.jsx';
import RentListScreen from './screens/admin/RentListScreen.jsx';
import RentImportScreen from './screens/admin/RentImportScreen.jsx';
import RentEditImportScreen from './screens/admin/RentEditImportScreen.jsx';
import RentEditImportImagesScreen from './screens/admin/RentEditImportImagesScreen.jsx';
import AddRentScreen from './screens/admin/AddRentScreen.jsx';
import AddStaffRent from './screens/admin/AddStaffRent.jsx';
import AddStaffTenant from './screens/admin/AddStaffTenant.jsx';
import AddStaffPayment from './screens/admin/AddStaffPayment.jsx';
import AddRentForm from './screens/admin/AddRentForm.jsx';
import RentScreen from './screens/RentScreen.jsx';
import RentProratedScreen from './screens/admin/RentProratedScreen.jsx';
import PaymentUserList from './screens/PaymentUserList';
import RentUserListScreen from './screens/admin/RentUserListScreen.jsx';
import TenantUserListScreen from './screens/admin/TenantUserListScreen.jsx';
import LandlordUserListScreen from './screens/admin/LandlordUserListScreen.jsx';
import StockNoteSearchReplaceScreen from './screens/admin/StockNoteSearchReplaceScreen.jsx';
import ExpenseSearchReplaceScreen from './screens/admin/ExpenseSearchReplaceScreen.jsx';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      <Route index={true} path='/' element={<CompoundScreen />} />
      <Route path='/search/:keyword' element={<CompoundScreen />} />
      <Route path='/page/:pageNumber' element={<CompoundScreen />} />
      <Route path='/page/:pageNumber' element={<HomeScreen />} />
      <Route
        path='/search/:keyword/page/:pageNumber'
        element={<CompoundScreen />}
      />
      
      <Route
        path='/house/CompoundScreen'
        element={<CompoundScreen />}
      />
      <Route
        path='/house/HomeScreen'
        element={<HomeScreen />}
      />
       <Route
        path='/houses'
        element={<Apphouse />}
      />
      <Route path='/dailyStock/:id' element={< DailyStockScreen/>} />
      <Route path='/dailystockuniquedates' element={< DailyStockUniqueDates />} />
      <Route path='/staffdailystock' element={< StaffDailyStock />} />
      <Route path='/dailystocksform' element={<DailyStocksForm />} />

      <Route path='/house/:id' element={<HouseScreen />} />
      
      <Route
          path='/admin/house/:id/edit'
          element={<HouseEditScreen />}
        /> {/* New route for House Edit */}
        <Route
          path='/house/:id/edit'
          element={<HouseStaffEditScreen />}
        /> {/* New route for House Edit */}
      <Route path='/expense/:id' element={<ExpenseScreen />} />
      <Route path='/payment/:id' element={<PaymentsScreen />} />
      <Route path='/deposit/:id' element={<DepositScreen />} />
      <Route path='/income/:id' element={<IncomeScreen />} />
      <Route path='/note/:id' element={<NoteScreen />} />
      <Route path='/bag/:id' element={<BagScreen />} />
      <Route path='/product/:id' element={<ProductScreen />} />
      <Route path='/cart' element={<CartScreen />} />
      <Route path='/usestockanalysis' element={<UseStockAnalysis />} />
      <Route path='/staffhomescreen' element={<StaffHomeScreen />} />
      <Route path='/cartform' element={<CartForm />} />
      <Route path='/staffinsurance' element={< StaffInsurance />} />
      <Route path='/staffsale' element={< StaffSale />} />
      <Route path='/stockanalysis' element={< StockAnalysis />} />
      <Route path='/stockreport' element={< StockReport />} />
      <Route path='/balance' element={< Balance />} />
      <Route path='/create/message' element={< AddUserNote />} />
      <Route path='/create/notification' element={< AddNoteScreen />} />
      <Route path='/create/expense' element={< AddExpenseScreen />} />
      <Route path='/create/payment' element={< AddPaymentScreen />} />
      <Route path='/create/tenant' element={< AddTenantScreen />} />
      <Route path='/create/rent' element={< AddRentScreen />} />

      <Route path='/create/form' element={< AddRentForm />} />
      <Route path='/create/product/excelform' element={< AddProductsFromExcelScreen />} />
      <Route path='/create/income/excelform' element={< AddIncomeFromExcelScreen />} />
      <Route path='/create/expense/excelform' element={< AddExpenseFromExcelScreen />} />
       <Route path='/create/multiproduct/excelform' element={< CreateMultipleProductScreen />} />
      <Route path='/create/staff/expense' element={< AddStaffExpense />} />
      <Route path='/create/income' element={< AddIncomeScreen />} />
      <Route path='/create/staff/income' element={< AddStaffIncome />} />
      <Route path='/create/deposit' element={< AddDepositScreen />} />
      <Route path='/create/staff/deposit' element={< AddStaffDeposit />} />
      <Route path='/create/staff/rent' element={< AddStaffRent />} />
      <Route path='/create/staff/tenant' element={< AddStaffTenant />} />
      <Route path='/create/staff/payment' element={< AddStaffPayment />} />
      <Route path='/staffsupply' element={< StaffSupply />} />
      <Route path='/staffstock' element={< StaffStock />} />
      <Route path='/staffnote' element={< StaffNote />} />
      <Route path='/staffopeningstock' element={< StaffOpeningStock />} />
      <Route path='/stafftransfer' element={< StaffTransfer />} />
      <Route path='/customeruserlist' element={<CustomerUserList/>} />
      <Route path='/customer/:id/edit' element={<CustomerStaffEditScreen />} />
      <Route path='/supplier/:id/edit' element={<SupplierStaffEditScreen />} />
      <Route path='/supplierlist' element={<SupplierUserList />} />
      <Route path='/admin/note/:id/edit' element={< NoteEditScreen />} />
      <Route path='/admin/bag/:id/edit' element={< BagEditScreen />} />
      <Route path='/bag/:id/edit' element={< BagStaffEditScreen />} />
      <Route path='/contact' element={<Appcontact />} />
      <Route path='/services' element={<Appservices />} />
      <Route path='/login' element={<LoginScreen />} />
      <Route path='/register' element={<RegisterScreen />} />
      <Route path='/salesform' element={<SalesForm />} />
      <Route path='/insurancesform' element={<InsurancesForm />} />
      <Route path='/supplysform' element={<SupplysForm />} />
      <Route path='/transfersform' element={<TransfersForm />} />
      <Route path='/purchasesform' element={<PurchasesForm />} />
      <Route path='/stocksform' element={<StocksForm />} />
      <Route path='/expenselist' element={<ExpenseUserList />} />
      <Route path='/paymentlist' element={<PaymentUserList />} />
      <Route path='/productlist' element={<ProductUserList />} />
      <Route path='/cashlist' element={<CashUserList />} />
      <Route path='/stockuniquedates' element={<StockUniqueDates />} />
      <Route path='/bankuserlist' element={<BankUserList />} />
      <Route path='/staffhouselist' element={<StaffHouseList />} />
      
      <Route path='/expense/:id/edit' element={<ExpenseStaffEditScreen />} />
      <Route path='/admin/deposit/:id/edit' element={<DepositEditScreen />} />
      <Route path='/deposit/:id/edit' element={<DepositStaffEditScreen />} />
      <Route path='/supply/:id/edit' element={<SupplysEditScreen />} />
      <Route path='/openingstocksform' element={<OpeningStocksForm />} />
      <Route path='' element={<PrivateRoute />}>
        <Route path='/shipping' element={<ShippingScreen />} />
        <Route path='/payment' element={<PaymentScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/sale/:id' element={<SaleScreen />} />
        <Route path='/insurance/:id' element={<InsuranceScreen />} />  
        <Route path='/product/:id/edit' element={<ProductStaffEditScreen />} />
        <Route path='/stock/:id' element={< StockScreen/>} />
        <Route path='/openingstock/:id' element={< OpeningStockScreen />} />
        <Route path='/transfer/:id' element={<TransferScreen />} />
        <Route path='/tenant/:id' element={<TenantScreen />} />
        <Route path='/rent/:id' element={<RentScreen />} />
        <Route path='/supply/:id' element={<SupplyScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />
        <Route path='/balancebyuserscreen' element={< BalanceByUserStaff />} />
        <Route path='/balancebycustomerscreen' element={< BalanceByCustomerStaff />} />
        <Route path='/rentproratedscreen' element={<RentProratedScreen />} />
        <Route path='/rentlistscreen' element={<RentUserListScreen />} />
        <Route path='/Tenantlistscreen' element={<TenantUserListScreen />} />
        <Route path='/landlordlist' element={<LandlordUserListScreen />} />

      </Route>
      {/* Admin users */}
      <Route path='' element={<AdminRoute />}>
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/dailyStock/:id/edit' element={<DailyStocksEditScreen />} />
        <Route path='/dailystockanalysis' element={< DailyStockAnalysis />} />
        <Route path='/dailystockreport' element={< DailyStockReport />} />
         <Route path='/netcash' element={< NetCash />} />
         <Route path='/alltotal' element={<AllTotal />} />
         <Route path='/adminform' element={<AdminForm />} />

         <Route path='/balancebycustomeradminscreen' element={< BalanceByCustomer />} />
         <Route path='/balancebyuseradminscreen' element={< BalanceByUser />} />
         <Route path='/admin/expensesearchreplace' element={<ExpenseSearchReplaceScreen />} />
        <Route path='/admin/stocknotesearchreplace' element={<StockNoteSearchReplaceScreen />} />

         <Route path='/admin/stocksearchreplace' element={<StocksSearchReplaceScreen />} />
        <Route path='/admin/transfersearchreplace' element={<TransfersSearchReplaceScreen />} />
        <Route path='/admin/supplysearchreplace' element={<SupplysSearchReplaceScreen />} />
        <Route path='/admin/salesearchreplace' element={<SalesSearchReplaceScreen />} />
        
       
         <Route path='/admin/bulkhouseeditscreen' element={<BulkExcelEditHouseScreen />} />
         <Route path='/admin/bulkhousecreatescreen' element={<BulkExcelCreateHouseScreen />} />

         <Route path='/admin/stockbulkeditscreen' element={<StockBulkEditScreen />} />
         <Route path='/income/:id/edit' element={<NetCashEdit />} />
         <Route path='/admin/supplysummary' element={<SupplySummary />} />
         <Route path='/admin/supplyinvoicesummary' element={<SupplyInvoiceSummary />} />
         <Route path='/admin/expenseinvoicesummary' element={<ExpenseInvoiceSummary />} />
        <Route path='/admin/expenseinvoices' element={<ExpenseInvoices />} />
        <Route path='/admin/salelist' element={<SaleListScreen />} />
        <Route path='/admin/insurancelist' element={<InsuranceListScreen />} />
        <Route path='/admin/stocklist' element={<StockListScreen />} />
        <Route path='/admin/openingstocklist' element={<OpeningStockListScreen />} />
        <Route path='/admin/transferlist' element={<TransferListScreen />} />
        <Route path='/admin/productlist' element={<ProductListScreen />} />
        <Route path='/admin/expenselist' element={<ExpenseListScreen />} />
        <Route path='/admin/paymentlist' element={<PaymentListScreen />} />
        <Route path='/admin/depositlist' element={<DepositListScreen />} />
        <Route path='/admin/notelist' element={<NoteListScreen />} />
        <Route path='/admin/baglist' element={<BagListScreen />} />
        <Route path='/update/income/excelform' element={< BulkIncomeUpdateWithImageUploadScreen />} />
        <Route path='/update/product/excelform' element={< BulkProductUpdateWithImageUploadScreen />} />
        <Route path='/update/expense/excelform' element={< BulkEditExpensesScreen />} />
        <Route path='/admin/incomeexpensecategories' element={<IncomeExpenseCategories />} />
        <Route path='/admin/expensecategory' element={<ExpenseCategory />} />
        <Route path='/admin/incomecategory' element={<IncomeCategory />} />
        <Route path='/admin/workingcapital' element={<WorkingCapital />} />
        <Route path='/reportstockscreen' element={< ReportStockScreen />} />
        <Route path='/stockreport' element={< StockReport />} />
        <Route path='/stockdatexpenses' element={< StockDateExpenses />} />
        
         <Route path='/admin/startstockscreen' element={<StartStockScreen />} />
        <Route
          path='/productlist/:pageNumber'
          element={<ProductListScreen />}
        />
        <Route
          path='/admin/purchaselistscreen'
          element={<PurchaseListScreen />}
        />

        <Route
          path='/admin/salelist/:pageNumber'
          element={<SaleListScreen />}
        />
        <Route
        path='/house/HomeScreen/:pageNumber'
        element={<HomeScreen />}
        />
        <Route
          path='/staffhouselist/:pageNumber'
          element={<StaffHouseList />}
        />
        <Route
          path='/admin/transferlist/:pageNumber'
          element={<TransferListScreen />}
        />
        <Route
          path='/admin/supplierbalance/'
          element={<SupplierBalanceScreen />}
        />
        <Route
          path='/admin/supplylist/:pageNumber'
          element={<SupplyListScreen />}
        />
        <Route
          path='/admin/stocklist/:pageNumber'
          element={<StockListScreen />}
        />
        <Route
          path='/admin/customerlist/:pageNumber'
          element={<CustomerListScreen />}
        />
        
        <Route
          path='/admin/landlordlist/:pageNumber'
          element={<LandlordListScreen />}
        />
        <Route
          path='/landlordlist/:pageNumber'
          element={<LandlordUserListScreen />}
        />
        
        <Route
          path='/admin/supplierlist/:pageNumber'
          element={<SupplierListScreen />}
        />
        <Route
          path='/admin/openingstocklist/:pageNumber'
          element={<OpeningStockListScreen />}
        />
        <Route
          path='/admin/expenselist/:pageNumber'
          element={<ExpenseListScreen />}
        />
        <Route
          path='/admin/expenselist/:pageNumber'
          element={<PaymentListScreen />}
        />
        <Route
          path='/admin/depositlist/:pageNumber'
          element={<DepositListScreen />}
        />
        <Route
          path='/netcash/:pageNumber'
          element={<NetCash />}
        />
        <Route
          path='/admin/notelist/:pageNumber'
          element={<NoteListScreen />}
        />
        <Route
          path='/admin/tenantlistscreen/:pageNumber'
          element={<TenantListScreen />}
        />
        <Route
          path='/admin/rentlistscreen/:pageNumber'
          element={<RentListScreen />}
        />
        <Route
          path='/admin/purchaselist/:pageNumber'
          element={<PurchaseListScreen />}
        />
        <Route
          path='/admin/houselist/:pageNumber'
          element={<HouseListScreen />}
        />
        <Route
          path='/admin/baglist/:pageNumber'
          element={<BagListScreen />}
        />
        <Route path='/admin/dailystocklist' element={<DailyStockListScreen />} />
        <Route path='/admin/houselist' element={<HouseListScreen />} /> {/* New route for House List */}
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/product/:id/edit' element={<ProductEditScreen />} />
        <Route path='/admin/sale/:id/edit' element={<SalesEditScreen />} />
        <Route path='/admin/insurance/:id/edit' element={<InsurancesEditScreen />} />
        <Route path='/admin/transfer/:id/edit' element={<TransfersEditScreen />} />
        <Route path='/admin/openingStock/:id/edit' element={<OpeningStocksEditScreen />} />
        <Route path='/admin/stock/:id/edit' element={<StocksEditScreen />} />
        <Route path='/admin/expense/:id/edit' element={<ExpenseEditScreen />} />
        <Route path='/admin/customer/:id/edit' element={<CustomerEditSreen />} />
        <Route path='/admin/payment/:id/edit' element={<PaymentEditScreen />} />
        <Route path='/admin/landlord/:id/edit' element={<LandlordEditScreen />} />
        <Route path='/admin/landlordimportscreen' element={<LandlordImportScreen />} />
        <Route path='/admin/landlordlist' element={<LandlordListScreen />} />
        <Route path='/admin/rentlistscreen' element={<RentListScreen />} />
        
        <Route path='/admin/tenant/:id/edit' element={<TenantEditScreen />} />
        <Route path='/admin/rent/:id/edit' element={<RentEditScreen />} />
        <Route path='/admin/tenantimportscreen' element={<TenantImportScreen />} />
        <Route path='/admin/tenantlistscreen' element={<TenantListScreen />} />
        <Route path='/admin/tenanteditimportscreen' element={<TenantEditImportScreen />} />
      
        <Route path='/admin/rentimportscreen' element={<RentImportScreen />} />
        <Route path='/admin/renteditimportscreen' element={<RentEditImportScreen />} />
        <Route path='/admin/renteditimportimagesscreen' element={<RentEditImportImagesScreen />} />
        


        <Route path='/admin/supplier/:id/edit' element={<SupplierEditScreen />} />
        <Route path='/admin/customerlist' element={<CustomerListScreen />} />
        <Route path='/admin/landlordeditimportscreen' element={<LandlordEditImportScreen />} />
        <Route path='/admin/customerimportscreen' element={<CustomerImportScreen />} />
        <Route path='/admin/customereditimportscreen' element={<CustomerEditImportScreen />} />
        <Route path='/admin/supplierlist' element={<SupplierListScreen />} />
        <Route path='/admin/supplylist' element={<SupplyListScreen />} />
        <Route path='/admin/adminuserprofile' element={<AdminProfileScreen />} />
        <Route path='/admin/adminuserscreen' element={<AdminUsersScreen />} />
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />
      </Route>
    </Route>
  ),
  

);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PayPalScriptProvider deferLoading={true}>
          <RouterProvider router={router} />
        </PayPalScriptProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
